function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import DNALoader from "../DNALoader";
import BounceLoader from "../BounceLoader";
import "./style.css";

var Loading = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Loading, _React$Component);

  function Loading() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      longerThan200MS: false
    });

    return _this;
  }

  var _proto = Loading.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.timeoutId = setTimeout(function () {
      _this2.setState({
        longerThan200MS: true
      });
    }, 200);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeoutId);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        loading = _this$props.loading,
        userStyle = _this$props.style,
        className = _this$props.className,
        _this$props$container = _this$props.containerStyle,
        containerStyle = _this$props$container === void 0 ? {} : _this$props$container,
        children = _this$props.children,
        _this$props$displayIn = _this$props.displayInstantly,
        displayInstantly = _this$props$displayIn === void 0 ? false : _this$props$displayIn,
        _this$props$bounce = _this$props.bounce,
        bounce = _this$props$bounce === void 0 ? false : _this$props$bounce,
        withTimeout = _this$props.withTimeout,
        inDialog = _this$props.inDialog,
        centeredInPage = _this$props.centeredInPage;
    var longerThan200MS = this.state.longerThan200MS;

    var style = _extends({}, userStyle, inDialog && {
      minHeight: 120
    });

    var LoaderComp = bounce || inDialog ? BounceLoader : DNALoader;

    if (loading || !children) {
      if (!displayInstantly && !longerThan200MS && (!bounce && !inDialog || withTimeout)) {
        return /*#__PURE__*/React.createElement("div", null);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "tg-loader-container tg-flex justify-center align-center",
        style: _extends({
          width: "100%"
        }, containerStyle, centeredInPage && {
          width: undefined,
          zIndex: 20,
          height: 10,
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, 0)"
        })
      }, /*#__PURE__*/React.createElement(LoaderComp, {
        style: style,
        className: className
      }));
    } else {
      return children || null;
    }
  };

  return Loading;
}(React.Component);

export { Loading as default };